import { useLocation, useNavigate } from "react-router-dom";
import { scrollToId } from "./scroll";

/* Scroll to a homepage section from any page. On the homepage it scrolls
   straight there; elsewhere it goes home and passes the section along, and
   ScrollManager (App.js) scrolls once the homepage has rendered. */
export const useGoToSection = () => {
    const location = useLocation();
    const navigate = useNavigate();
    return (id) => {
        if (location.pathname === "/") {
            scrollToId(id);
        } else {
            navigate("/", { state: { section: id } });
        }
    };
};
